import { permissions } from '@mpk/shared/domain';

enum EcosioSettingsPermissionsEnum {
  None = 0,

  /**
   * Manage the ecosio settings.
   */
  ManageSettings = 1,
}

export const EcosioSettingsPermissions = permissions(EcosioSettingsPermissionsEnum, {
  featureId: 'Settings',
});
